import { ArrowBack } from '@mui/icons-material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Typography
} from '@mui/material'
import { useState } from 'react'

import { CustomerEntry } from '../../sdk'
import CustomerChatPanel from '../ChatServices/CustomerChatPanel'
import { RepairOrderChatDialog } from '../ChatServices/RepairOrderChatDialog'

export default function DviMessage({
  repairOrderId,
  repairOrderNumber,
  customer,
  generateRoSummary
}: {
  repairOrderId: string
  repairOrderNumber: number
  customer: CustomerEntry | undefined
  generateRoSummary?: () => Promise<string>
}) {
  const [open, setOpen] = useState(false)
  const [tab, setTab] = useState('1')

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Message
      </Button>
      <Dialog fullScreen open={open}>
        <DialogTitle component="div">
          <AppBar>
            <Grid
              direction="row"
              container
              alignItems="center"
              sx={{
                height: '3.5rem'
              }}>
              <Grid item xs={3}>
                <Box>
                  <IconButton
                    onClick={() => setOpen(false)}
                    sx={{ color: 'primary.light' }}>
                    <ArrowBack />
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography component="h1" variant="h3" textAlign="center">
                  Message
                </Typography>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </AppBar>
        </DialogTitle>
        <DialogContent sx={{ mt: '24px' }}>
          <TabContext value={tab}>
            <TabList
              onChange={(event: React.SyntheticEvent, newValue: string) => {
                setTab(newValue)
              }}
              centered>
              <Tab label="SMS" value="1" />
              <Tab label="CHAT" value="2" />
            </TabList>
            <TabPanel value="1" sx={{ p: 0 }}>
              {customer && (
                <CustomerChatPanel
                  customerChatIsOpen={open}
                  setCustomerChatIsOpen={setOpen}
                  customerOfRepairOrder={customer}
                  generateRoSummary={generateRoSummary}
                  dviDisplay
                />
              )}
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}>
              <RepairOrderChatDialog
                {...{
                  repairOrderId,
                  repairOrderNumber
                }}
                dialogOpen={open}
                setDialogOpen={setOpen}
                dviDisplay
              />
            </TabPanel>
          </TabContext>
        </DialogContent>
      </Dialog>
    </>
  )
}
